export default "__VITE_PUBLIC_ASSET__3f4a8c78__"